import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

interface GuestLoginPromptProps {
  serviceName: string;
  promptKey: string;
}

const GuestLoginPrompt = ({ serviceName, promptKey }: GuestLoginPromptProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const storageKey = `ncludeGuestLoginPrompt:${promptKey}`;
  const [show, setShow] = useState(false);
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (!localStorage.getItem("token") && !sessionStorage.getItem(storageKey)) {
      sessionStorage.setItem(storageKey, "shown");
      setShow(true);
    }
  }, [storageKey]);

  const continueAsGuest = () => setShow(false);

  const signIn = () => {
    navigate("/login", { state: { returnTo: location.pathname } });
  };

  return (
    <Modal
      show={show}
      onHide={continueAsGuest}
      onEntered={() => titleRef.current?.focus()}
      centered
      id="guest-login-modal"
      aria-labelledby="guest-login-modal-title"
      aria-describedby="guest-login-modal-description"
    >
      <Modal.Header closeButton>
        <Modal.Title
          as="h2"
          id="guest-login-modal-title"
          ref={titleRef}
          tabIndex={-1}
        >
          Sign in for a more personalized experience
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p id="guest-login-modal-description">
          You can use {serviceName} as a guest. Sign in if you would like your
          account and saved activity to be available across devices.
        </p>
        <div className="guest-login-actions">
          <button type="button" className="guest-continue-button" onClick={continueAsGuest}>
            Continue as guest
          </button>
          <button type="button" className="guest-sign-in-button" onClick={signIn}>
            Sign in
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GuestLoginPrompt;
